export default "__VITE_ASSET__DFDxuw7o__"